import axios from "../../../axios";

export default {
  login(email, pwd, remember) {
    return axios.post("", {
      query: `
        mutation {
          logIn (
            email: "${email}",
            password: "${pwd}",
            remember: ${remember}
          ) {
            token,
            user {
              id,
              name,
              email,
              image,
              role {
                id,
                name
              },
              social_networks {
                facebook,
                twitter,
                instagram
              }
            }
          }
        }
      `,
    });
  },
  refreshToken() {
    return axios.post("", {
      query: `mutation refreshToken { refreshToken { token } }`,
    });
  },
};
